<template>
  <el-container style="width: 100%">
    <el-header>
      <el-button
        round
        @click="createClick"
      >{{generateCustomizeString('add')}}</el-button>
      <el-button round @click="onRefersh">{{generateCustomizeString('refresh')}}</el-button>
    </el-header>
    <el-table
      ref="pagesForm"
      :data="pagesForm"
      tooltip-effect="dark"
      v-loading="fetchLoding"
      style="width: 96%; margin: 20px auto; margin-bottom:60px;"
    >
      <el-table-column
        v-if="$i18n.locale == 'zh'"
        prop="name"
        :label="generateCustomizeString('pageName')"
      >
      </el-table-column>
      <el-table-column
        v-else-if="$i18n.locale == 'en'"
        prop="enName"
        :label="generateCustomizeString('pageName')"
      >
      </el-table-column>
      <el-table-column
        prop="url"
        :label="generateCustomizeString('pageUrl')"
        width="410"
      >
        <template slot-scope="scope">
          <a :href="mobileUrl + '/storeWiki/' + scope.row.url_suffix" target="_blank">
            <el-tag>{{mobileUrl + '/storeWiki/' + scope.row.url_suffix}}</el-tag>
          </a>
        </template>
      </el-table-column>
      <el-table-column
        prop="sort_by"
        :label="generateCustomizeString('sortWeight')"
      >
      </el-table-column>
      <el-table-column
        prop="is_show"
        :label="generateCustomizeString('showInStoreWiki')"
      >
        <template slot-scope="scope">
          <el-tag
            v-if="scope.row.is_show === 1"
            type="success"
            close-transition
          >{{generateCustomizeString('moduleReady')}}</el-tag>
          <el-tag
            v-else
            type="info"
            close-transition
          >{{generateCustomizeString('moduleWaitForReview')}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="delete_enable"
        :label="generateCustomizeString('isDeleteEnable')"
      >
        <template slot-scope="scope">
          <el-tag
            v-if="scope.row.delete_enable === 1"
            type="success"
            close-transition
          >{{generateCustomizeString('canDelete')}}</el-tag>
          <el-tag
            v-else
            type="info"
            close-transition
          >{{generateCustomizeString('cannotDelete')}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        :label="generateCustomizeString('operate')"
        width="180"
      >
        <template slot-scope="scope">
          <el-button
            @click="editClick(scope.row)"
            type="text"
            size="small"
          >{{generateCustomizeString('edit')}}</el-button>
          <el-button
            @click="deleteClick(scope.row)"
            type="text"
            size="small"
            :disabled="scope.row.delete_enable === 0"
          >{{generateCustomizeString('delete')}}</el-button>
          <el-dialog
            :title="generateCustomizeString('noticeConfirm')"
            :visible.sync="dialogVisible"
            width="30%"
            :append-to-body="true"
          >
            <span>{{generateCustomizeString('deletePage')}}</span>
            <span
              slot="footer"
              class="dialog-footer"
            >
              <el-button @click="dialogVisible = false">{{generateCustomizeString('deleteCancel')}}</el-button>
              <el-button
                type="primary"
                @click="deletePage()"
              >{{generateCustomizeString('deleteConfirm')}}</el-button>
            </span>
          </el-dialog>
        </template>
      </el-table-column>
    </el-table>
    <el-footer style="position: fixed; bottom: 0; width: 100%; z-index:9999; padding-top:15px;">
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-size="15"
        layout="total, prev, pager, next"
        :total="currentTotal"
      >
      </el-pagination>
    </el-footer>
  </el-container>
</template>

<script>
import { generateCustomizeString } from '@/utils/i18n'
import request from '@/utils/request'

export default {
  name: 'PcCmsPages',
  data() {
    return {
      pagesForm: [],
      selectDeleteId: 0,
      currentPage: 1,
      currentTotal: 0,
      dialogVisible: false,
      fetchLoding: false,
      mobileUrl: this.$store.state.shop.shop_custom_host
        ? 'http://' + this.$store.state.shop.shop_custom_host
        : process.env.VUE_APP_MOBILE_URL + this.$store.state.shop.shop_domain_prefix
    }
  },
  methods: {
    generateCustomizeString,
    onRefersh() {
      this.fetchData(this.currentPage)
    },
    handleCurrentChange(val) {
      this.fetchData(val)
    },
    editClick(row) {
      this.$router.push({
        name: 'EditPage',
        params: {
          pageId: row.id
        }
      })
    },
    createClick() {
      this.$router.push({
        name: 'CreatePage'
      })
    },
    deleteClick(row) {
      this.selectDeleteId = row.id
      this.dialogVisible = true
    },
    viewClick(row) {},
    fetchData(page) {
      if (this.fetchLoding) return
      this.fetchLoding = true

      request({
        url: '/page-list',
        method: 'get',
        params: {
          page: page
        }
      })
        .then(response => {
          const data = response.data
          const meta = response.meta

          this.pagesForm = data
          for (var i = 0; i < this.pagesForm.length; i++) {
            switch (this.pagesForm[i].name) {
              case '新手指南':
                this.pagesForm[i].enName = "Beginner's Guide"
                break
              case '常见问题':
                this.pagesForm[i].enName = 'Questions'
                break
              case '发货须知':
                this.pagesForm[i].enName = 'About Shipping'
                break
              case '物流查询':
                this.pagesForm[i].enName = 'Shipping Tracking'
                break
              case '赔付条款':
                this.pagesForm[i].enName = 'Refund Terms'
                break
              case '公司简介':
                this.pagesForm[i].enName = 'About Us'
                break
              case '联系我们':
                this.pagesForm[i].enName = 'Contact Us'
                break
              case '会员等级说明':
                this.pagesForm[i].enName = 'Member Level'
                break
              case '招聘信息':
                this.pagesForm[i].enName = 'Recruitment Information'
                break
              case '在线支付':
                this.pagesForm[i].enName = 'Online Payment'
                break
              case '转账支付':
                this.pagesForm[i].enName = 'Transfer Payment'
                break
              case '海外配送':
                this.pagesForm[i].enName = 'Oversea Delivery'
                break
              case '包装说明':
                this.pagesForm[i].enName = 'Package Instruction'
                break
              case '身份证上传':
                this.pagesForm[i].enName = 'Upload ID'
                break
              case '运费说明':
                this.pagesForm[i].enName = 'Shipping Payment'
                break
              case '验货签收':
                this.pagesForm[i].enName = 'Inspect Package'
                break
              case '新西兰奶粉直邮资质':
                this.pagesForm[i].enName = 'New Zealand milk powder shipping qualification'
                break
              case '奶粉常见问题Q&A':
                this.pagesForm[i].enName = 'Common problems of milk powder'
                break
              case '购买协议':
                this.pagesForm[i].enName = 'Purchase Agreement'
                break
              default:
                this.pagesForm[i].enName = this.pagesForm[i].name
            }
          }
          this.currentPage = meta.current_page
          this.currentTotal = meta.total
        })
        .catch(error => {
          console.warn(error)
        })
        .finally(() => {
          this.fetchLoding = false
        })
    },
    deletePage() {
      if (this.selectDeleteId === 0) return
      request({
        url: 'page/' + this.selectDeleteId,
        method: 'delete'
      })
        .then(res => {
          if (res.status === 0) {
            this.$message({
              message: this.generateCustomizeString('deletedSuccessfully'),
              type: 'success'
            })
          } else {
            this.$message.error(this.generateCustomizeString('deleteFailed'))
          }
        })
        .catch(error => {
          console.log(error)
          this.$message.error(this.generateCustomizeString('deleteFailed'))
        })
        .finally(() => {
          this.fetchData(this.currentPage)
          this.dialogVisible = false
          this.selectDeleteId = 0
        })
    }
  },
  created: function() {
    if (location.host.includes('ieshop.co.nz')) {
      this.mobileUrl = 'https://m.ieshop.co.nz/m/' + this.$store.state.shop.shop_domain_prefix
    }
    this.fetchData(1)
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.el-header,
.el-footer {
  background-color: #efefef;
  // color: #333;
  text-align: left;
  line-height: 60px;
}
</style>
